/* eslint-disable react/jsx-no-bind */
import { h, Component } from 'preact';
import { Button } from '../../button';
import { trackNavClick } from '../../tracking/google';
import { Link } from '../../link';
import styles from './styles.module.scss';
import { Config } from '../../context';
import {
  NOTIFICATION_COMPONENT_TYPES,
  DefaultNotification,
} from './notification-components';
import { toTimeAgo } from './notification-utils';
import { urlQueryToObject } from '@buzzfeed/bf-utils/lib/query-string';
import { ChevronRightMiniIcon } from '../../svg/icons/chevron-right-mini';
import { NotificationsEmptyStateIcon } from '../../svg/icons/notifications-empty-state';

export class UnreadIcon extends Component {
  render({ count }) {
    return <div className={styles.unreadIcon}> {count} </div>;
  }
}

// returns a no-op for already-read notifications so the "mark as read" click handler is safe to always attach
export const getMarkHandler = (notification, onMarkAsReadClicked) =>
  notification.read ? () => {} : () => onMarkAsReadClicked(notification, false);

export function NotificationsEmptyState() {
  return (
    <div className={styles.notificationEmptyState}>
      <div className={styles.notificationEmptyStateImage}>
        <NotificationsEmptyStateIcon />
      </div>
      <div className={styles.notificationsEmptyStateText}>
        Where’s everyone?
      </div>
      <div>You have no notifications</div>
    </div>
  );
}

export class Notification extends Component {
  clickHandler({ onClick, label, location, url, ga }) {
    return async (evt) => {
      evt.preventDefault();
      trackNavClick({ label, location, ga });
      await onClick(evt);
      window.location = url;
    };
  }

  getNotificationBody({
    type,
    meta,
    url,
    trackingData,
    time,
  }) {
    const NotificationComponent =
      NOTIFICATION_COMPONENT_TYPES[type] || DefaultNotification;
    return (
      <NotificationComponent
        {...meta}
        url={url}
        trackingData={trackingData}
        time={time}
      />
    );
  }

  getNotificationTracking({ content_id, content_type, id_seq, meta, url }) {
    let cetLabel = 'notification-link';
    let cetTracking = { item_name: id_seq };

    if (content_type === 'comment') {
      cetLabel = 'comment-notification-link';
      cetTracking['item_name'] = content_id;

      // TODO: We should eventually remove the url query parsing once all comment
      // events have been updated to use the comments ID as the `content_id` value.
      const queryObject = urlQueryToObject(url);
      if (queryObject['comment_id']) {
        let commentId = queryObject['comment_id'].split('_')[0];
        let intId = parseInt(commentId, 10);
        if (!isNaN(intId)) {
          cetTracking['item_name'] = intId;
        }
      }

      if (meta['buzz_id']) {
        cetTracking['target_content_id'] = meta['buzz_id'].toString();
      }
    }

    return { cetLabel, cetTracking };
  }

  render({
    onClick = () => {},
    label,
    location,
    meta,
    type,
    url,
    triggered_at,
    trackingData = {},
    index,
    read = false,
    ...notification
  }) {
    trackingData['position_in_unit'] = index;
    const { cetLabel, cetTracking } = this.getNotificationTracking({
      ...notification,
      meta,
      url,
    });

    return (
      <li>
        <Config.Consumer>
          {(config) => (
            <div
              className={`${styles.notification} ${read ? '' : styles.notificationUnread}`}
            >
              <Link
                href={url}
                location={'userMenu'}
                label={cetLabel}
                onClick={this.clickHandler({
                  onClick,
                  label,
                  location,
                  url,
                  ga: config.ga,
                })}
                trackingData={{
                  ...cetTracking,
                  ...trackingData,
                }}
              >
                {this.getNotificationBody({
                  type,
                  meta,
                  url,
                  trackingData,
                  time: toTimeAgo(new Date(triggered_at)),
                })}
              </Link>
            </div>
          )}
        </Config.Consumer>
      </li>
    );
  }
}

export class Notifications extends Component {
  render({
    notifications,
    totalUnreadCount,
    onMarkAsReadClicked,
    onShowAllNotifications,
  }) {
    const visibleNotifications = notifications.slice(0, 3);
    const hasNotifications = visibleNotifications.length > 0;
    const showSeeAll = notifications.length > 3;

    return (
      <div className={styles.notifications}>
        <div className={styles.notificationsTitleContainer}>
          <div className={styles.notificationsTitle}>
            <span>Notifications</span>
            {totalUnreadCount > 0 && <UnreadIcon count={totalUnreadCount} />}
          </div>
          {showSeeAll && (
            <Button
              className={styles.markAllAsReadButton}
              onClick={onShowAllNotifications}
              location={'userMenu'}
              label={'see-all-notifications'}
            >
              <span>See All</span>
              <ChevronRightMiniIcon aria-hidden={true} />
            </Button>
          )}
        </div>
        {hasNotifications ? (
          <div className={styles.notificationsContainer}>
            <ul>
              {visibleNotifications.map((notification, index) => (
                <Notification
                  onClick={getMarkHandler(notification, onMarkAsReadClicked)}
                  location={'userMenu'}
                  label={'notification-read'}
                  index={index}
                  {...notification}
                />
              ))}
            </ul>
          </div>
        ) : (
          <NotificationsEmptyState />
        )}
      </div>
    );
  }
}
